import React, { useState } from 'react'
import { X } from 'lucide-react'
import MessageDialog from '../../../shared/ui/MessageDialog'

const CopyModal = ({ isOpen, onClose, onCopy }) => {
  const [destinationId, setDestinationId] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [showErrorDialog, setShowErrorDialog] = useState(false)

  const handleCopy = async () => {
    if (!destinationId.trim()) {
      setShowErrorDialog(true)
      return
    }

    setIsLoading(true)
    try {
      await onCopy(destinationId)
      setDestinationId('')
    } catch (error) {
      // Error handling is done in the parent component
    } finally {
      setIsLoading(false)
    }
  }

  const handleClose = () => {
    setDestinationId('')
    onClose()
  }

  const handleErrorDialogClose = () => {
    setShowErrorDialog(false)
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-testid="copy-modal">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">データコピー</h3>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            data-testid="close-modal-button"
          >
            <X size={20} />
          </button>
        </div>

        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-4">
            コピー先のIDを指定してください。
          </p>
          
          <div>
            <label htmlFor="destination-id-input" className="block text-sm font-medium text-gray-700 mb-2">
              コピー先ID
            </label>
            <input
              id="destination-id-input"
              type="text"
              value={destinationId}
              onChange={(e) => setDestinationId(e.target.value)}
              placeholder="ID"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              autoComplete="off"
              data-testid="destination-id-input"
            />
          </div>
        </div>

        <div className="flex items-center justify-end space-x-3">
          <button
            onClick={handleClose}
            disabled={isLoading}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors disabled:opacity-50"
            data-testid="cancel-button"
          >
            キャンセル
          </button>
          <button
            onClick={handleCopy}
            disabled={isLoading || !destinationId.trim()}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50"
            data-testid="copy-button"
          >
            {isLoading ? 'コピー中...' : 'コピー'}
          </button>
        </div>
      </div>
      
      <MessageDialog
        isOpen={showErrorDialog}
        onClose={handleErrorDialogClose}
        title="入力エラー"
        message="IDを入力してください"
        type="error"
        buttonText="OK"
      />
    </div>
  )
}

export default CopyModal

